import { defineStore } from 'pinia';
import apolloClient from "../plugins/apollo";
import { getSliders } from "@/gqls/colections";
export const useSliderStore = defineStore('slider', {
    state: () => ({
        sliders: []
    }),
    getters: {
        getSliders: (state) => state.sliders
    },
    actions: {
        async fetchSliders(page = 1, limit = 100) {

            await apolloClient
                .query({
                    query: getSliders,

                    fetchPolicy: "cache-first",
                    variables: {
                        input: {

                            page: page,
                            limit: limit
                        }
                    },

                }).then(async res => {

                    this.sliders = res.data.getSliders.data;

                })
                .catch(error => {
                    this.error = error
                })
        },
    }
});
